import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.1 3a.93.93 0 0 1 .625.237.9.9 0 0 1 .325.563l.65 3.5q.05.399-.025.675-.075.275-.275.475L6.975 10.9q.5.926 1.187 1.787.687.863 1.513 1.663.774.774 1.625 1.437.849.663 1.8 1.213l2.35-2.35a1.4 1.4 0 0 1 .587-.338q.363-.111.713-.062l3.45.7q.35.1.575.363.225.262.225.587v4.05q0 .45-.3.75t-.75.3q-3.124 0-6.175-1.362t-5.55-3.863-3.863-5.55T3 4.05q0-.45.3-.75t.75-.3z" })
});
export default SvgPhone;
